import React, { useState, useEffect } from "react";
import Select from "react-select";
import { getApplicantProfiles } from "./Axios";

const ApplicantProfileSelect = props => {
  const [applicant_profiles, setApplicantProfiles] = useState([]);

  const handleChange = selectedOption => {
    props.handleChange(selectedOption, "applicant_profile");
  };

  useEffect(() => {
    getApplicantProfiles((response) => {
      if (response && response.data) {
        const newApplicantProfiles = response.data.map((applicant_profile) => ({
          value: applicant_profile.id,
          label: applicant_profile.name,
          uniqueIdentifier: applicant_profile.unique_identifier,
        }));
        setApplicantProfiles(newApplicantProfiles);
      }
    });
  }, []);

  return (
    <Select
      inputId="trabajando-applicant-profiles-search"
      onChange={handleChange}
      options={applicant_profiles}
      placeholder="Buscar y seleccionar un perfil académico"
      value={
        applicant_profiles.find(
          (option) => option.value === props.value?.value
        ) || null
      }
      getOptionLabel={(e) => `${e.label}`}
      filterOption={(option, input) => {
        const searchTerm = input.toLowerCase();
        const { label } = option.data;
        return (
          label.toLowerCase().includes(searchTerm)
        );
      }}
      isSearchable={true}
    />
  );
};

export default ApplicantProfileSelect;

